import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import AttributionModelIcon from "../../../../../assets/images/icons/AttributionModelIcon";
import BriaEnvironment from "../../../../../assets/images/icons/BriaEnvironment";
import { LongArrowRightIcon } from "../../../../../assets/images/icons/LongArrowRightIcon";
import RoyaltiesDistributionIcon from "../../../../../assets/images/icons/RoyaltiesDistributionIcon";
import UserEnvironment from "../../../../../assets/images/icons/UserEnvironment";
import styles from "./AttributionDiagram.module.scss";

interface AttributionDiagramProps {
	type: "fullPrivacy" | "noComputeCost";
	className?: string;
}

const AttributionDiagram = ({ type, className }: AttributionDiagramProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "models.attributionService.chooseArchitecture.diagram" });

	const isFullPrivacy = type === "fullPrivacy";

	return (
		<Box className={clsx(styles.diagram, className)}>
			<Box className={styles.diagramSection}>
				<Box className={clsx(styles.diagramHeader, { [styles.noBorder]: !isFullPrivacy })}>
					<UserEnvironment />
					<Typography className={styles.environmentTitle}>{t("yourEnvironment")}</Typography>
				</Box>
				{isFullPrivacy && (
					<Box className={styles.diagramItems}>
						<Box className={styles.diagramItem}>
							<AttributionModelIcon />
							<Typography className={styles.diagramItemTitle}>{t("attributionModel")}</Typography>
						</Box>
					</Box>
				)}
			</Box>

			<Box className={styles.divider}>
				<LongArrowRightIcon />
				<Typography className={styles.dividerTitle}>{t("api")}</Typography>
				<Typography className={styles.dividerSubTitle}>{isFullPrivacy ? t("irreversibleVectors") : t("images")}</Typography>
			</Box>

			<Box className={styles.diagramSection}>
				<Box className={styles.diagramHeader}>
					<BriaEnvironment />
					<Typography className={styles.environmentTitle}>{t("briaEnvironment")}</Typography>
				</Box>
				<Box className={styles.diagramItems}>
					{isFullPrivacy ? (
						<Box className={styles.diagramItem}>
							<RoyaltiesDistributionIcon />
							<Typography className={styles.diagramItemTitle}>{t("royaltiesDistribution")}</Typography>
						</Box>
					) : (
						<>
							<Box className={styles.diagramItem}>
								<AttributionModelIcon />
								<Typography className={styles.diagramItemTitle}>{t("attributionModel")}</Typography>
							</Box>
							<Box className={styles.diagramItem}>
								<RoyaltiesDistributionIcon />
								<Typography className={styles.diagramItemTitle}>
									{t("royaltiesDistribution")}
								</Typography>
							</Box>
						</>
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default AttributionDiagram;
